module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_yq_lb.d15239e6.png";